import { render, staticRenderFns } from "./97czjsth.vue?vue&type=template&id=a39ecc9a&"
import script from "./97czjsth.vue?vue&type=script&lang=js&"
export * from "./97czjsth.vue?vue&type=script&lang=js&"
import style0 from "./97czjsth.vue?vue&type=style&index=0&id=a39ecc9a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports